// SPDX-License-Identifier: AGPL-3.0-or-later

import {Endpoints} from '@app/features/app/constants/Endpoints';
import {http} from '@app/features/platform/transport/RestTransport';
import type {
	GuildOnboardingResponse,
	GuildOnboardingResponsesRequest,
	GuildOnboardingResponsesResponse,
	GuildOnboardingUpdateRequest,
} from '@fluxer/schema/src/domains/guild/GuildOnboardingSchemas';

export async function getGuildOnboarding(guildId: string): Promise<GuildOnboardingResponse> {
	const response = await http.get<GuildOnboardingResponse>(Endpoints.GUILD_ONBOARDING(guildId));
	return response.body;
}

export async function updateGuildOnboarding(
	guildId: string,
	payload: GuildOnboardingUpdateRequest,
): Promise<GuildOnboardingResponse> {
	const response = await http.put<GuildOnboardingResponse>(Endpoints.GUILD_ONBOARDING(guildId), {
		body: payload,
	});
	return response.body;
}

export async function submitGuildOnboardingResponses(
	guildId: string,
	payload: GuildOnboardingResponsesRequest,
): Promise<GuildOnboardingResponsesResponse> {
	const response = await http.put<GuildOnboardingResponsesResponse>(Endpoints.GUILD_ONBOARDING_RESPONSES(guildId), {
		body: payload,
	});
	return response.body;
}
